import { Building2, Factory, Globe, Zap, type LucideIcon } from 'lucide-react'

/**
 * The four core sectors, in display order.
 *
 * Translation keys are spelled out rather than derived from `id` so the typed
 * `t()` can verify each one against the English bundle at compile time.
 *
 * Icons stand in for the design's Material Symbols, which would have meant
 * loading an external icon font: public → Globe, electric_bolt → Zap,
 * apartment → Building2, precision_manufacturing → Factory.
 */
export interface Sector {
  id: string
  icon: LucideIcon
  image: string
  titleKey:
    | 'sectors.trading.title'
    | 'sectors.energy.title'
    | 'sectors.realEstate.title'
    | 'sectors.mining.title'
  descriptionKey:
    | 'sectors.trading.description'
    | 'sectors.energy.description'
    | 'sectors.realEstate.description'
    | 'sectors.mining.description'
}

export const SECTORS: readonly Sector[] = [
  {
    id: 'trading',
    icon: Globe,
    image: 'sector-trading',
    titleKey: 'sectors.trading.title',
    descriptionKey: 'sectors.trading.description',
  },
  {
    id: 'energy',
    icon: Zap,
    image: 'sector-energy',
    titleKey: 'sectors.energy.title',
    descriptionKey: 'sectors.energy.description',
  },
  {
    id: 'realEstate',
    icon: Building2,
    image: 'sector-real-estate',
    titleKey: 'sectors.realEstate.title',
    descriptionKey: 'sectors.realEstate.description',
  },
  {
    id: 'mining',
    icon: Factory,
    image: 'sector-mining',
    titleKey: 'sectors.mining.title',
    descriptionKey: 'sectors.mining.description',
  },
]
